"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const styled_tools_1 = require("styled-tools");
exports.IconButton = styled_1.default(react_core_1.ButtonBase) `
  color: ${styled_tools_1.prop('theme.black')};
  outline: none;
  cursor: pointer;
  padding: 2px 2px;

  &:hover {
    background-color: rgba(46, 40, 55, 0.25);
  }
`;

//# sourceMappingURL=IconButton.js.map
